import { render } from "./MostImprovedWidget.vue?vue&type=template&id=24a21dc6&scoped=true"
import script from "./MostImprovedWidget.vue?vue&type=script&lang=js"
export * from "./MostImprovedWidget.vue?vue&type=script&lang=js"

import "./MostImprovedWidget.vue?vue&type=style&index=0&id=24a21dc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a21dc6"]])

export default __exports__